module.exports = __webpack_public_path__ + "img/art.d1a22a0e.svg";